module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "d2-d5f88a5f148ed-d1e263"
    }
  }, [_c('span', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('p', {
    staticClass: "prelims-epigraph "
  }, [_vm._v("Luna is a stern schoolmistress;")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph "
  }, [_vm._v("those who have lived through her harsh lessons")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph-space-after "
  }, [_vm._v("have no cause to feel ashamed.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph-source "
  }, [_vm._v("– Robert A. Heinlein, "), _c('em', [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("The Moon is a Harsh Mistress")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be2c22a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781448303595_epub_epi.vue
// module id = 75
// module chunks = 0